export default "/assets/images/big-sneeze-crop.1722968c5f248e18.png";